import { useSelector, shallowEqual } from "react-redux";
import SavingsHighlight from "app/components/ui/SavingsHighlight/SavingsHighlight";
import { FormattedMessage, useIntl } from "react-intl";
import PropTypes from "prop-types";
import { getSavingsData } from "app/pages/Booking/bookingSelectors";
import { BAGGAGE_TRANSLATION_KEYS } from "app/constants";

const SavingsHighlightContainer = props => {
	const { savingsData = {} } = useSelector(mapStateToProps, shallowEqual);
	const { savingsList = {}, amountSaved = 0 } = savingsData;
	const intl = useIntl();

	const transformedSavingsList = [];

	if (savingsList?.roomBoard?.amount > 0) {
		transformedSavingsList.push({
			label: <FormattedMessage id="savings.room.board.label" />,
			amount: savingsList.roomBoard.amount,
		});
	}

	Object.keys(savingsList.baggages).forEach(key => {
		const baggageSaving = savingsList.baggages[key];
		if (baggageSaving.amount > 0) {
			const baggageLabel = intl.formatMessage({
				id: BAGGAGE_TRANSLATION_KEYS[key].plural,
			});
			// Lowercase first letter: baggage label is also used standalone (capitalized),
			// but here it's interpolated mid-sentence in "Réduction {baggage}".
			transformedSavingsList.push({
				label: (
					<FormattedMessage
						id="savings.baggage.label"
						values={{
							baggage: baggageLabel.charAt(0).toLowerCase() + baggageLabel.slice(1),
						}}
					/>
				),
				amount: baggageSaving.amount,
			});
		}
	});

	if (savingsList?.promotion?.amount > 0) {
		transformedSavingsList.push({
			label: (
				<FormattedMessage
					id="savings.promo.code.label"
					values={{ code: savingsList.promotion.code }}
				/>
			),
			amount: savingsList.promotion.amount,
		});
	}

	if (savingsList?.credits?.amount > 0) {
		transformedSavingsList.push({
			label: <FormattedMessage id="price.detail.credits.label" />,
			amount: savingsList.credits.amount,
		});
	}

	return amountSaved > 0 ? (
		<SavingsHighlight
			savingsList={transformedSavingsList}
			amountSaved={amountSaved}
			savingsData={savingsData}
			{...props}
		/>
	) : null;
};

SavingsHighlightContainer.propTypes = {
	savingsData: PropTypes.shape({
		savingsList: PropTypes.object,
		amountSaved: PropTypes.number,
	}),
};

const mapStateToProps = state => {
	return {
		savingsData: getSavingsData(state),
	};
};

export default SavingsHighlightContainer;
